module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_bhojpuri.15a3205f.mp3";